// extracted by mini-css-extract-plugin
export default {"iconBtn":"IconButton_iconBtn__d2v2U","danger":"IconButton_danger__SU8BH"};